import { Dialog, DialogActions } from "@mui/material"
import { useEffect, useState } from "react"
import { buscarSolicitacoesPorStatus, buscarTimelineSolicitacao } from "../../../../services/api-planejamento-tributario.service"
import TimelineIcon from '@mui/icons-material/Timeline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import styles from './styles.module.css'
import { useNavigate } from "react-router-dom";
import TableCard from "../../../../components/TableCard";
import ModalTimeLine from "../../../../components/ModalTimeline";
import WhiteButton from "../../../../components/WhiteButton";
import CloseIcon from '@mui/icons-material/Close';
import MensagemErro from "../../../../components/MensagemErro";
import Loading from "../../../../components/Loading";


const ModalSolicitacoes = ({ open, onClose, status, title }) => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [timeline, setTimeline] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
    const [msg, setMsg] = useState('')

    const navigate = useNavigate()
    const columns = [
        'ID', 'Processo'
    ]

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await buscarSolicitacoesPorStatus(status)
                setData(handleOrganizaData(response ?? []));
            } catch (error) {
                setMsg(error?.response?.data?.mensagem || error?.message || "Erro ao carregar solicitações.")
                setOpenSnackbarErro(true)
            } finally {
                setLoading(false)
            }
        }
        status && fetchData()
    }, [status])

    const handleOrganizaData = (response) => {
        const list = Array.isArray(response) ? response : [];
        const newData = list.map(item => {
            return {
                idSolicitacao: item.idSolicitacao,
                processo: item.processo,
                botoes: [
                    { icon: <TimelineIcon />, title: 'TIMELINE', onClick: () => handleOpenModal(item.idSolicitacao) },
                    { icon: <MoreVertIcon />, title: 'VER DETALHES', onClick: () => navigate(item.href) },
                ]
            }
        })

        return newData;
    }

    const handleOpenModal = async (id) => {
        try {
            const response = await buscarTimelineSolicitacao(id)
            setTimeline(Array.isArray(response) ? response : []);
            setOpenModal(true)
        } catch (error) {
            setMsg(error?.response?.data?.mensagem || error?.message || "Erro ao carregar timeline.")
            setOpenSnackbarErro(true)
        }
    }

    const handleCloseSnackbarErro = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackbarErro(false);
    };

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const handlePesquisaPorTexto = () => { }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth='xl'
                fullWidth
            >
                    <TableCard
                        iconHeader={<FactCheckIcon fontSize='1rem' sx={{ marginRight: '1rem' }} />}
                        titleHeader={title}
                        data={data}
                        setData={setData}
                        columns={columns}
                        loading={loading}
                        textHeaderCard='idSolicitacao'
                        handleDebounce={handlePesquisaPorTexto}
                    />
                <ModalTimeLine
                    onClose={handleCloseModal}
                    open={openModal}
                    timeline={timeline}
                />
                <DialogActions>
                    <WhiteButton
                        textValue='Fechar'
                        clickFunction={onClose}
                        contentIcon={<CloseIcon />}
                    />
                </DialogActions>
            </Dialog>
            <MensagemErro
                open={openSnackbarErro}
                handleClose={handleCloseSnackbarErro}
                msg={msg}
            />
        </>
    )
}

export default ModalSolicitacoes
